import { useState } from 'react';
import { faqItems } from '@/mocks/categories';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Często Zadawane Pytania
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Odpowiadamy na najczęściej zadawane pytania dotyczące Kakobuy Spreadsheet
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <div key={i} className="bg-white rounded-xl border border-background-200 overflow-hidden">
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 text-left cursor-pointer hover:bg-background-50 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">{item.question}</span>
                <i
                  className={`ri-add-line text-lg text-foreground-400 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === i ? 'rotate-45' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 md:px-6 pb-5 text-sm text-foreground-600 leading-relaxed border-t border-background-100 pt-4">
                  {item.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqItems.map((item) => ({
                '@type': 'Question',
                name: item.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: item.answer,
                },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}